const tableStructure = {
    props: {
        headers: Array,
        row: Object,
        model: String,
        list: Array
    }
};

export default tableStructure;